// Ficha de la app en Google Play a la que apuntan los enlaces de descarga.
export const URL_GOOGLE_PLAY =
  'https://play.google.com/store/apps/details?id=com.bookoll.app';